'use client'
import { useParams } from 'next/navigation'
import styled from 'styled-components'
import { MODALS } from '@/context'
import { useModal } from '@/hooks'
import type { TypeLang } from '@/utils'
import { vw, mq } from '@/styles'
import { Figure, Logo, Link, Burger, Dropdown } from '@/components'

const mediaInstagram = {
  type: 'svg' as const,
  alt: 'instagram',
  src:'/images/svg/i--instagram.svg',
  size: { width: 24, height: 24 }
}
const mediaTiktok = {
  type: 'svg' as const,
  alt: 'TikTok logo',
  src: '/images/svg/i--tiktok.svg',
  size: { width: 24, height: 24 }
}

const arrayOptions = [
  {value: 'ES', path:'/'},
  {value: 'CAT', path:'/cat'},
  {value: 'EN', path:'/en'}
]

export const Navbar = () => {
  const { isActive:isActiveModalMenu, toggle: toggleModalMenu } = useModal(MODALS.MENU)
  const { lang } = useParams() as { lang: TypeLang }

  return (
    <Nav $menuOpen={isActiveModalMenu}>
      <Logo name={'iluzione'}/>
      <Burger onClick={toggleModalMenu} menuOpen={isActiveModalMenu} />
      <Wrapper>
        <Link href='https://www.instagram.com/iluzione_restaurant/' className='instagram'>
          <Figure media={mediaInstagram}/>
        </Link>
        <Link href='https://www.tiktok.com/@iluzione_restaurant'>
          <Figure media={mediaTiktok}/>
        </Link>
        <Dropdown className='detail-dropdown' trigger={lang.toUpperCase()} options={arrayOptions} direction={'down'} />
      </Wrapper>
    </Nav>
  )
}



const Nav = styled.nav<{ $menuOpen: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 6;
  justify-content: space-between;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;

  /* MOBILE LANDSCAPE */
  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    height: 78px;
    padding: 15px 17px;

    > .logo {
      figure {
        height: 28px;
        width: 207px;
      }
    }

    > button {
      width: 60px;

      &,
      figure {
        height: 60px;
        width: 60px;
      }
    }

    ${mq.lessThan('tablet')} {
      background-color: ${({ $menuOpen }) => $menuOpen ? 'var(--color-dark--green)' : 'transparent'};
    }
  }

  height:${vw(90, 'mobile')};
  padding:${vw(15, 'mobile')} ${vw(17, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    height: 131px;
    padding: 21.8px 24.7px;
  }

  ${mq.greaterThan('tablet')} {
    grid-column: 9 / span 2;
    height: ${vw(78, 'desktop')};
    padding: ${vw(25, 'desktop')} ${vw(50, 'desktop')};
  }

  ${mq.greaterThan('container')} {
    grid-column: 9 / span 2;
    height: 63.32px;
    padding: 20.295px 40.59px;
  }
`

const Wrapper = styled.div`
  display: none;

  ${mq.greaterThan('tablet')} {
    align-items: center;
    display: flex;
    flex-direction: row;
  }

  figure {
    ${mq.greaterThan('tablet')} {
      display:block;
      height: ${vw(28, 'desktop')};
      margin-right: ${vw(20, 'desktop')};
      width: ${vw(28, 'desktop')};
    }

    ${mq.greaterThan('container')} {
      display:block;
      height: 22.72px;
      margin-right: 16.2px;
      width: 22.72px;
    }
  }
`
